import { render, staticRenderFns } from "./RegisterApproval.vue?vue&type=template&id=0500d9b0&"
import script from "./RegisterApproval.vue?vue&type=script&lang=ts&"
export * from "./RegisterApproval.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterApproval.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports